/**
 * Created by Samyan Wahla on 9/3/2015.
 */
(function () {
    'use strict';

    angular
        .module('tmx-app')
        .controller('forgotpasswordCtrl', ['$scope','$http','ENV','$location','$mdToast','$auth','$mdDialog','$translate','ServerExceptionService','ToastService','APP_CONSTANTS',ForgotpasswordCtrl]);
                
    function ForgotpasswordCtrl($scope,$http,ENV,$location,$mdToast,$auth,$mdDialog,$translate,ServerExceptionService,ToastService,APP_CONSTANTS) {
                
        var forgetCtrl=this;
        $scope.ForgottenPassword = 'ForgottenPassword';
        $scope.ForgottenPasswordMessage = 'ForgottenPasswordMessage';
        $scope.Email = 'Email';
        $scope.GetEmailLink = 'GetEmailLink';
        $scope.HaveAccount = 'HaveAccount';
        $scope.JoinNow = 'JoinNow';
                
        $scope.changeCulture = function(culture) {
            localStorage.setItem('culture', culture);
            $translate.use(culture);
        }
                
                //$scope.form = {};
////////////  WATCHING FOR CHANGES IN THE ERROR in HTTP RESPONSE IN FORGOT PASSWORD/////////////////////////////////////
        $scope.$watch(function () { return ServerExceptionService.Displaymsg}, function (newVal, oldVal) {
            if ($scope.watch_count > 1) {
                return;
            }
            if (typeof newVal !== 'undefined'&& $scope.watch_count == 1) {
                $scope.error = ServerExceptionService.Displaymsg;
                $scope.dataLoading = false; // remove the loading imaging when error is displayed
                        //empty the message string as soon as page reloads or user moves away from the current page
                $scope.watch_count = $scope.watch_count + 1;
                ServerExceptionService.Displaymsg = oldVal;//to differentiate old value from new value when user signs
                        // in multiple time using incorrect username and password and the server returns the same error

                $scope.$on("$destroy", function(){
                    ServerExceptionService.Displaymsg = "";
                });
            }
        });
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.submit = function () {
            $scope.dataLoading = true;
            $scope.watch_count = 1;
                    // OAuth.isAuthenticated();
            $scope.error="";

            if(ENV.backend == 'http://tmxprovisioningapi.azurewebsites.net/api'){
                $scope.userData.clientId=APP_CONSTANTS.cliendId;
            }
            else{
                $scope.userData.clientId= APP_CONSTANTS.cliendId;
            }
            $http.post(ENV.AuthServer+'/api/Account/ForgotPassword', $scope.userData).then(handleSuccess);


        }


        function handleSuccess(data) {
            $scope.dataLoading = false;
            $scope.form.$setPristine();
            $scope.form.$setUntouched();


                    //$mdToast.show(
                    //    $mdToast.simple()
                    //        .content('We have sent an email to ' + $scope.userData.email +'. Kindly check your email for further instructions.')
                    //        .position('top right')
                    //        .hideDelay(6000)
                    //);
            ToastService.showCustomToast("success",'We have sent an email to ' +$scope.userData.email +'. Kindly check your email for further instructions.');
                    //$mdDialog.show(
                    //    $mdDialog.alert()
                    //        .parent(angular.element(document.querySelector('#forgotPassword')))
                    //        .clickOutsideToClose(true)
                    //        .title('Email Link')
                    //        .content('We have sent an email to ' +$scope.userData.email +'. Kindly check your email for further instructions.' )
                    //        .ariaLabel('Alert Dialog Demo')
                    //        .ok('Ok')
                    //
                    //
                    //) .then(
                    //    function(){
                    //        $scope.form.$setPristine();
                    //        $scope.form.$setUntouched();
                    //
                    //    }
                    //);
            $scope.userData={};

        }


                /*function handleError(data)
                {
                    //$scope.dataLoading = false;
                    //$scope.error= data.data.message;
                }*/


    }


})();